// Orchestrates Overview, Demographics, Question Charts, and Theme Charts sections.

import React from "react";
import { OverviewSection } from "./overview-section";
import { DemographicsSection } from "./demographics-section";
import { QuestionChartsSection } from "./question-charts-section";
import { ThemeChartsSection } from "./theme-charts-section";

export function SurveyTab(props) {
    return (
        <>
            <OverviewSection
                totalResponses={props.totalResponses}
                completionData={props.completionData}
            />
            <DemographicsSection
                pieDemographicData={props.pieDemographicData}
            />
            <QuestionChartsSection
                questionEngagementData={props.questionEngagementData}
                questionByTotalEngagement={props.questionByTotalEngagement}
                questionByTotalEngagementForChart={props.questionByTotalEngagementForChart}
                questionByContributors={props.questionByContributors}
                questionByContributorsForChart={props.questionByContributorsForChart}
                questionByResponses={props.questionByResponses}
                questionByResponsesForChart={props.questionByResponsesForChart}
                questionByUnique={props.questionByUnique}
                questionByUniqueForChart={props.questionByUniqueForChart}
                openChartTables={props.openChartTables}
                toggleChartTable={props.toggleChartTable}
                legendDirection={props.legendDirection}
                getLegendPosition={props.getLegendPosition}
                getBottomMargin={props.getBottomMargin}
                getBottomMarginNoLegend={props.getBottomMarginNoLegend}
                getLegendItemWidth={props.getLegendItemWidth}
            />
            <ThemeChartsSection
                themeEngagementData={props.themeEngagementData}
                themeByTotalEngagement={props.themeByTotalEngagement}
                themeByTotalEngagementForChart={props.themeByTotalEngagementForChart}
                themeByContributors={props.themeByContributors}
                themeByContributorsForChart={props.themeByContributorsForChart}
                themeByResponses={props.themeByResponses}
                themeByResponsesForChart={props.themeByResponsesForChart}
                themeByUnique={props.themeByUnique}
                themeByUniqueForChart={props.themeByUniqueForChart}
                openChartTables={props.openChartTables}
                toggleChartTable={props.toggleChartTable}
                legendDirection={props.legendDirection}
                getLegendPosition={props.getLegendPosition}
                getBottomMargin={props.getBottomMargin}
                getBottomMarginNoLegend={props.getBottomMarginNoLegend}
                getLegendItemWidth={props.getLegendItemWidth}
            />
        </>
    );
}
